export default "__VITE_ASSET__NmFW4$v8__"